$(document).ready(function () {
  $.validator.addMethod("refer_earn_regex", function(value, element, regexpr) {          
    return regexpr.test(value);
  });
  $('.new_refer_earn').validate({
    rules: {
      "refer_earn[referral_Candidate_name]": {
        required: true,
        minlength: 2,
        maxlength: 40,
        refer_earn_regex: /^[a-zA-Z ]+$/
      },
      "refer_earn[referral_Candidate_email]": {
        required: true,
        refer_earn_regex: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
      },

      "refer_earn[referral_Candidate_contact_number]": {
        required: true,
        minlength: 10,
        maxlength: 10,                   
        refer_earn_regex: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      },

      "refer_earn[image]": {
        required: true
      },

      "refer_earn[your_name]": {
        required: true,
        minlength: 2,
        maxlength: 40,
        refer_earn_regex: /^[a-zA-Z ]+$/
      },

      "refer_earn[your_email]": {
        required: true,
        refer_earn_regex: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
      },

      "refer_earn[your_contact_number]": {
        required: true,
        minlength: 10,
        maxlength: 10,                   
        refer_earn_regex: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      }
    },
    messages: {
      "refer_earn[referral_Candidate_name]": {
        required: 'The first name is required.',
        minlength: 'The first name must be 2-40 characters long.',
        maxlength: 'The first name must be 2-40 characters long.',
        refer_earn_regex: 'The first name can only consist of alphabets.'
      },
      "refer_earn[referral_Candidate_email]": {
        required: 'The email is required.',
        refer_earn_regex: 'The email pattern must followed.'
      },
      "refer_earn[referral_Candidate_contact_number]": {
        required: 'The phone number is required.',
        minlength: 'minlength 10 digits are allowed.',
        refer_earn_regex: 'The phone contain only 10 digits.'
      },
      "refer_earn[image]": {
        required: 'The resume file is required.'
      },
      "refer_earn[your_name]": {
        required: 'The description is required.',
        minlength: 'The first name must be 2-40 characters long.',
        maxlength: 'The first name must be 2-40 characters long.',
        refer_earn_regex: 'The first name can only consist of alphabets.'
      },
      "refer_earn[your_email]": {
        required: 'The email is required.',
        refer_earn_regex: 'The email pattern must followed.'
      },
      "refer_earn[your_contact_number]": {
        required: 'The phone number is required.',
        minlength: 'minlength 10 digits are allowed.',
        refer_earn_regex: 'The phone contain only 10 digits.'
      }
    }
  });
});


$(document).ready(function(){
  $(".success").mouseenter(function(){
    $('.bonusAmount').each(function() {
      var $this = $(this),
      countTo = $this.attr('data-max');

      $({ countNum: $this.text()}).animate({
        countNum: countTo
      },
      {
        duration: 1500,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
      });
    });
  });
});